import React, { useCallback, useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { BaseError } from 'src/editor/api/errors/base-error'
import { deletePageRequest } from 'src/editor/api/website-pages-api'
import { ConfirmationDialogWindow } from 'src/editor/shared/ui-lib/modal-window/dialog-window/confirmation-dialog-window'

export interface DeletePageModalProps {
  pageId: number
  pageName?: string
  isOpened: boolean
  onClose: () => void
}

export const DeletePageModal = ({
  pageId,
  pageName,
  isOpened,
  onClose,
}: DeletePageModalProps) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const handleRemovePage = useCallback(async () => {
    if (!pageId) {
      return
    }
    try {
      setIsLoading(true)
      await deletePageRequest({ pageId })

      toast.success(
        t('website_settings.sidebar.page_settings.updated_successfully'),
      )

      if (onClose) {
        onClose()
      }
    } catch (error) {
      if (error instanceof BaseError) {
        toast.error(error?.response?.detail)
      }
    } finally {
      setIsLoading(false)
    }
  }, [pageId, t, onClose])

  return (
    <ConfirmationDialogWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t('website_settings.sidebar.pages_management.delete_page.title')}
      description={t(
        'website_settings.sidebar.pages_management.delete_page.description',
        { pageName },
      )}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        isLoading,
        onClick: handleRemovePage,
        children: t('components.core.actions.remove'),
      }}
    />
  )
}
